<template>
  <div>
    <crm-generic 
      title="Contatos" 
      namespace="contacts" 
      :defaultEditing="defaultEditing" 
      :searchFields="['name', 'email']" 
      :isAddVisible="true" 
      @open-modal="onOpenModal" 
      :extras="extras">
      <template v-slot:header>
        <th>Nome</th>
        <th>E-mail</th>
        <!-- <th>Telefone</th> -->
      </template>
      <template v-slot:item="{ item }">
        <td>
          {{ item.name }}
        </td>
        <td>{{ item.email }}</td>
      </template>
      <!-- <template v-slot:fields="{ editingItem }">
        <generic-form :fields="fields" :editing="editingItem"></generic-form>
      </template> -->
    </crm-generic>
  </div>
</template>
<script>
import CRMGeneric from './CRMGeneric';
import states from '../../utils/states';
import GenericForm from '../../components/GenericForm';

export default {
  components: {
    'crm-generic': CRMGeneric,
    GenericForm,
  },
  data() {
    return {
      defaultEditing: {
        name: '',
        email: '',
      },
    }
  },
  computed: {
    fields() {
      const fields = [{
        text: 'Ativo',
        name: 'active',
        type: 'checkbox'
      }, {
        text: 'E-mail',
        name: 'email',
        type: 'email',
      }];
      return fields;
    }
  },
  methods: {
    onOpenModal(data) {
      
    }
  }
}

</script>
